
<table class="stripped-table mat-elevation-z2 pipeline-table">
  <thead>
  <tr>
    @for(field of tableFields; track $index){
      <th>{{ field }}</th>
    }
  </tr>
  </thead>
  <tbody>
    @for(row of data.filteredData; track row.id){
      <tr class="data-row" (click)="toggleExpandedRow(row)" [class.expanded-row]="row.isExpanded">
        @for(field of tableFields; track $index){
          <td [ngClass]="{'past-date' : itemIsPastDate(row, field)}">
            @if(row[field] && row[field] !== null && row[field] !== ''){
              @if(field == 'Project Name'){
                <span>
                  <a href="{{getProjectLink(row, field)}}" target="_blank" class="table-link">{{row[field]}}</a>
                  @if(row["Tags"].length>0){
                    <mat-icon class="tag-icon" [matTooltip]="$safeNavigationMigration(row['Tags']?.join(', '))">sell</mat-icon>
                  }
                </span>
              } @else if(field == 'LOI Signed'){
                {{row[field] | date: 'MM/dd/yyyy'}}
                <small [ngClass]="{'expiration-date': true}">Exp: <span [ngClass]="{'past-date': itemIsPastDate(row, 'LOI Expiration')}">{{row['LOI Expiration'] | date: "MM/dd/yyyy"}}</span></small>
              } @else {
                @switch (tableFormats.get(field)){
                  @case ('percent100'){
                    {{ row[field] | percent: '1.0-0' }}
                  }
                  @case('percent100.4'){
                    {{row[field] | percent: '1.4-4'}}
                  }
                  @case('date') {
                    {{row[field] | date: 'MM/dd/yyyy'}}
                  }
                  @case('boolean'){
                    @if(row[field]=='1'){
                      Yes
                    } @else {
                      No
                    }
                  }
                  @case('dollars'){
                    {{row[field] | currency: 'USD': 'symbol': '1.0-0'}}
                  }
                  @default {
                    @if(Array.isArray(row[field])){
                      {{ row[field].length> 0 ? row[field].join(', ') : '--' }}
                    } @else if (isStringField(row, field)) {
                      {{ row[field] }}
                    } @else {
                      {{ Object.values(row[field]).join(', ') }}
                    }
                  }
                }
              }
            } @else {
              --
            }
          </td>
        }

      </tr>
      @if(row.isExpanded){
        <tr class="detail-row">
          <td [attr.colspan]="tableFields.length">
            <div class="expanded-detail">
              @if(row.details!==null){
                <div class="row align-top">
                  <div class="col-md-6">
                    <pipelines-panel-notes [detail]="row.details"></pipelines-panel-notes>
                  </div>
                  <div class="col-md-6">
                    <pipelines-panel-notes-syndicated [detail]="row.details"></pipelines-panel-notes-syndicated>
                  </div>
                </div>
                <pipelines-panel-property-info [detail]="row.details"></pipelines-panel-property-info>
                <pipelines-panel-project-attributes [detail]="row.details"></pipelines-panel-project-attributes>
                <pipelines-panel-kpis [detail]="row.details"></pipelines-panel-kpis>
                <pipelines-panel-project-dates [detail]="row.details"></pipelines-panel-project-dates>
                <pipelines-panel-project-credits [detail]="row.details"></pipelines-panel-project-credits>
                <pipelines-panel-credit-outlets [detail]="row.details"></pipelines-panel-credit-outlets>
                <pipelines-panel-loans [detail]="row.details"></pipelines-panel-loans>
                <pipelines-panel-pricing-details [detail]="row.details"></pipelines-panel-pricing-details>
                <pipelines-panel-esg [detail]="row.details"></pipelines-panel-esg>
                <pipelines-panel-participants [detail]="row.details" [participantType]="'people'"></pipelines-panel-participants>
                <pipelines-panel-participants [detail]="row.details" [participantType]="'fund'"></pipelines-panel-participants>
                <pipelines-panel-participants [detail]="row.details" [participantType]="'thirdParty'"></pipelines-panel-participants>
              }
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</table>
